export const selectAllSigns = (state) => state.dashboard.signs;
export const selectSignsStatus = (state) => state.dashboard.isLoading;
export const selectSignsError = (state) => state.dashboard.error;

export const selectSignImages = (state) => state.dashboard.signImages;
export const selectSignImagesStatus = (state) => state.dashboard.signImagesLoading;
export const selectSignImagesError = (state) => state.dashboard.signImagesError;

export const selectgpsData = (state) => state.dashboard.gpsData;
export const selectgpsDatasStatus = (state) => state.dashboard.GpsDataLoading;
export const selectgpsDataError = (state) => state.dashboard.gspdata;

export const selectEvents = (state) => state.dashboard.events;
export const selectEventsStatus = (state) => state.dashboard.eventsStatus;
export const selectEventsError = (state) => state.dashboard.eventsError;
export const selectEventsTotal = (state) => state.dashboard.eventsTotal;

export const deleteSignStatus = (state) => state.dashboard.removeEventLoading;
export const deleteSignError = (state) => state.dashboard.removeEventError;

export const alterSignStatus = (state) => state.dashboard.changeSignLoading;
export const alterSignError = (state) => state.dashboard.changeSignError;

export const repositionSignsStatus = (state) => state.dashboard.repositionSignsLoading;
export const repositionSignsError = (state) => state.dashboard.repositionSignsError;

export const editDriveNameStatus = (state) => state.dashboard.editDriveNameLoading;
export const editDriveNameError = (state) => state.dashboard.editDriveNameError;

export const nearestGpsData = (state) => state.dashboard.nearestGpsData;
export const nearestGpsDataStatus = (state) => state.dashboard.nearestGpsDataLoading;
export const nearestGpsDataError = (state) => state.dashboard.nearestGpsDataError;

export const addNewSign = (state) => state.dashboard.addNewSign;
export const addNewSignStatus = (state) => state.dashboard.addNewSignLoading;
export const addNewSignError = (state) => state.dashboard.addNewSignError;

export const eventImageUrlLoading = (state) => state.dashboard.imageUrlLoading;
export const eventImageUrl = (state) => state.dashboard.imageUrl;
export const eventImageUrlError = (state) => state.dashboard.imageUrlError;
